var s=t=>`https://assets.tfx.market/${t.toLowerCase()}.svg`;

export { s as a };
